import { render, staticRenderFns } from "./w-areaid-company.vue?vue&type=template&id=446b7b16&"
import script from "./w-areaid-company.vue?vue&type=script&lang=js&"
export * from "./w-areaid-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports